import React, { useState, useEffect } from "react";
import { localStore } from "../../helpers/localStorage";
import firebase from "../../helpers/firebase";
import StepsRenderer from "../UiElements/StepsRenderer";
import NewExercise from "./NewExercise";
import Alert from "@material-ui/lab/Alert";

function ShowSteps() {
  const db = firebase.firestore();
  const sessionId = localStore.getSession();

  const [steps, setSteps] = useState();
  const correctAnswer = localStore.getAnswer();
  const [zeroResponses, setZeroResponses] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const loadAnswers = async () => {
    try {
      const doc = await db
        .collection("sessions")
        .doc(sessionId)
        .collection("answers")
        .get()
        .then((querySnapshot) => {
          if (!querySnapshot.empty) {
            let docs = querySnapshot.docs.map((doc) => {
              return doc.data();
            });

            return docs;
          }
          return null;
        });
      if (!doc || !doc.length) {
        setZeroResponses(true);
        return null;
      }

      return doc;
    } catch (err) {
      console.log(err);
    }
  };

  const fetchStatement = async () => {
    setIsLoading(true);
    return await db
      .collection("sessions")
      .doc(sessionId)
      .get()
      .then((docSnapshot) => {
        if (docSnapshot.exists) {
          let data = docSnapshot.data();
          if (data.problemStatement) {
            setIsLoading(false);
            return data.problemStatement.latex;
          }
        } else {
          setIsLoading(false);
          return null;
        }
      });
  };

  const combineSimilarSteps = (data, result) => {
    if (!data || !result) {
      return false;
    }
    let combinedSteps = {};
    let maxSteps = 1;
    for (let i = 0; i < maxSteps; i++) {
      const list = data.map((item, i, itemFullList) => {
        const newStepsList = item.steps.map((stepItem, j, stepArray) => {
          let result = "";
          if (
            (j === 0 &&
              stepItem.indexOf("\\") > -1 &&
              stepItem.indexOf("=") > -1) ||
            stepItem.indexOf("\\\\") > -1 ||
            j === stepArray.length - 1 ||
            (j > 0 && j < stepArray.length - 1 && stepItem.indexOf("=") > -1)
          ) {
            result = stepItem;
          } else {
            itemFullList.map((initArrayItem, index) => {
              if (
                initArrayItem.steps.length === item.steps.length &&
                initArrayItem.steps[j] &&
                initArrayItem.steps[j].indexOf("\\\\") > -1 &&
                initArrayItem.steps[j].indexOf(stepItem) > -1
              ) {
                result = initArrayItem.steps[j];
              } else if (index !== i) {
                const stepIndexWithReplace = initArrayItem.steps.findIndex(
                  (item) => item.includes(stepItem)
                );
                if (stepIndexWithReplace > 0) {
                  const extraString =
                    initArrayItem.steps[stepIndexWithReplace - 1] &&
                    initArrayItem.steps[stepIndexWithReplace - 1].split(
                      /\\\\+/
                    )[1];
                  result = extraString + "\\\\" + stepItem;
                }
                if (stepIndexWithReplace === 0) {
                  result = initArrayItem.steps[index];
                }
              }
            });
          }

          return result;
        });
        return { steps: newStepsList };
      });

      list.forEach((v, index) => {
        let steps = v["steps"]
          .reduce(
            (accumulator, currentValue) => accumulator + "\\\\" + currentValue
          )
          .split(/\\\\+/)
          .filter((item) => item !== result)
          .map((item, i, array) => {
            if (item.indexOf("=") === -1) {
              return null;
            }
            if (i === 0 && item.indexOf("=") !== -1) {
              return item;
            }
            return array[i - 1]
              ? array[i - 1].indexOf("=") === -1
                ? array[i - 1] + "\\\\" + item
                : item
              : null;
          })
          .filter(Boolean);

        steps.map((stepItem, k) => {
          if (stepItem.indexOf("\\\\") === -1) {
            list.map((item) => {
              const currentStepIndex = item.steps.findIndex(
                (item) => item.indexOf(steps[k]) > -1
              );
              if (
                i !== index &&
                steps[k].indexOf("\\\\") === -1 &&
                item.steps[k].indexOf("\\\\") > -1 &&
                currentStepIndex > -1
              ) {
                const rowsList =
                  item.steps[currentStepIndex - 1].split(/\\\\+/);
                const extraActionRow =
                  rowsList.length === 2 && rowsList[1].indexOf("=") === -1
                    ? rowsList[1]
                    : rowsList.length > 2 && rowsList[2].indexOf("=") === -1
                    ? rowsList[2]
                    : rowsList[0];
                steps[k] = extraActionRow + "\\\\" + steps[k];
              }
            });
          }
        });
        let stepsLength = steps.length;
        maxSteps = maxSteps < stepsLength ? stepsLength : maxSteps;
        let isLastStep = steps.length === i + 1;
        let step = steps[i];

        if (step) {
          if (i === 0) {
            if (!combinedSteps[step]) {
              combinedSteps[step] = {
                count: 1,
                steps: {},
                isAnswer: isLastStep,
              };
            } else {
              combinedSteps[step].count++;
            }
          } else {
            let depthArray = {};
            let key = steps[0];
            let currentSelection = combinedSteps[key];

            depthArray[key] = currentSelection;

            for (let k = 1; k <= i; k++) {
              key = steps[k];
              if (currentSelection["steps"][key]) {
                currentSelection = currentSelection["steps"][key];
                if (k === i) {
                  currentSelection.count++;
                }
                depthArray[key] = currentSelection;
              } else {
                depthArray[key] = { count: 1, steps: {}, isAnswer: isLastStep };
              }
            }

            for (let l = Object.keys(depthArray).length - 1; l > 0; l--) {
              let key = Object.keys(depthArray)[l];
              let item = depthArray[key];
              let keyPrevious = Object.keys(depthArray)[l - 1];

              depthArray[keyPrevious]["steps"][key] = item;
            }
          }
        }
      });
    }

    setSteps({
      data: combinedSteps,
      total_responses: data.length,
      startingEquation: result,
    });
  };

  const getConvertedSteps = (arrayOfSteps) => {
    let steps = [];
    let pointer = 0;

    arrayOfSteps.forEach((v, i) => {
      if (i === 0) {
        steps.push(v);
      } else if (v.includes("=")) {
        if (!steps[pointer].includes("=")) {
          steps[pointer] += "\\\\" + v;
        } else {
          steps.push(v);
          pointer++;
        }
      } else {
        steps[pointer] += "\\\\" + v;
      }
    });

    return steps;
  };
  useEffect(async () => {
    let statement = null;
    if (localStore.getProblemStatement()) {
      statement = localStore.getProblemStatement().latex;
    }
    try {
      const answers = await loadAnswers();
      const result = statement ? statement : await fetchStatement();
      const rows = answers.map((item) => {
        if (item.steps[0] === statement) {
          return { steps: getConvertedSteps([...item.steps]) };
        } else {
          return { steps: getConvertedSteps([statement, ...item.steps]) };
        }
      });

      combineSimilarSteps(rows, result);
    } catch (err) {
      console.log(err);
    }
  }, []);

  const NoResponseFound = () => (
    <>
      <Alert className="error-top" severity="warning">
        No response found!
      </Alert>
      <NewExercise />
    </>
  );
  return (
    <>
      {zeroResponses ? <NoResponseFound /> : ""}
      {!isLoading && steps ? (
        <StepsRenderer data={steps} correctAnswer={correctAnswer} />
      ) : (
        ""
      )}
    </>
  );
}

export default ShowSteps;
